import React, { useEffect, useContext, useState } from "react";
import { observer } from "mobx-react";
import { useLocation } from "react-router-dom";
import { AuthService } from "../services/AuthService";
import { ContextStore } from "./../store/ContextStore";
import SidebarNav from "./SidebarNav";

const COLLAPSE_KEY = "admin-sidebar-collapsed";

function Sidebar(props) {
	const authService = new AuthService();
	const { authStore } = useContext(ContextStore);
	const id = authStore.getId();
	const jwt = authStore.getToken();
	const user = authStore.getUser();
	const location = useLocation();
	const [collapsed, setCollapsed] = useState(() => {
		try {
			return localStorage.getItem(COLLAPSE_KEY) === "1";
		} catch (e) {
			return false;
		}
	});

	useEffect(() => {
		if (id && jwt) {
			const fetchUser = async () => {
				try {
					await authService.getUser(id);
				} catch (err) {
					console.log(err.message);
				}
			};

			!user && fetchUser();
			authService.authVerify(jwt);
		} else {
			window.location.assign("/admin/login");
		}
		// run on navigation only, not on every re-render
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id, jwt, location.pathname]);

	const toggleCollapsed = () => {
		setCollapsed((c) => {
			try {
				localStorage.setItem(COLLAPSE_KEY, c ? "0" : "1");
			} catch (e) {}
			return !c;
		});
	};

	return (
		<aside className={`main-sidebar${collapsed ? " is-collapsed" : ""}`}>
			<SidebarNav collapsed={collapsed} onToggleCollapse={toggleCollapsed} />
		</aside>
	);
}
export default observer(Sidebar);
